import { Box } from "@twilio-paste/core/box";
import { css, styled } from "@twilio-paste/styling-library";
import { SITE_HEADER_HEIGHT, SITE_SCROLL_SPACE } from "../../constants";

export const TableOfContentsList = styled(Box)(() =>
    css({
        margin: 0,
        padding: 0,
        listStyle: "none",
        borderLeftWidth: 1,
        borderLeftStyle: "solid",
        borderLeftColor: "colorBorderWeak",
        /* Fix overflowing on long pages.
         * Formula = total view height - header height - 2x spacing around table of contents
         */
        maxHeight: `calc((((100vh - ${SITE_HEADER_HEIGHT}) - ${SITE_SCROLL_SPACE})) - 4rem)`,
        overflow: "auto"
    })
);
